module.exports = __webpack_public_path__ + "static/media/CTLI_4-315w.736272b5.webp";